import Navigation from '../components/garage/navigation'
import Hero from '../components/garage/hero'
import Features from '../components/garage/features'
import Pricing from '../components/garage/pricing'
import FAQ from '../components/garage/faq'
import GetStarted from '../components/garage/getting-started'
import Footer from '../components/Footer'

export default function Home() {
    return(
        <>
        <Navigation/>
        <Hero/>
        <Features/>
        <Pricing/>
        <FAQ/>
        <GetStarted/>   
        <Footer/>
        </>
    )
} 